import React from 'react';
import { Col, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";
import * as Icons from 'assets/icons';
import { AppConstants } from 'constant';
import { AppUtils } from 'utils';

const { PATH_NEWS } = AppConstants;

const NewsCard = ({ disabled = false, el, t }) => {
  if (disabled) {
    return (
      <Col key={'news-' + el.id} className="col-6">
        <ContentView el={el} t={t} />
      </Col>
    )
  }

  return (
    <Col key={'news-' + el.id} className="col-6">
      <Link to={PATH_NEWS + '/' + el.id} className="clickable">
        <ContentView el={el} t={t} />
      </Link>
    </Col >
  )
}

const ContentView = ({ el, t }) => (
  <div className={'card card-news card-' + el.type.toLowerCase()} style={{ height: '100%' }}>
    <Image src={el.featuredImage} alt={el.featuredImage} className="card-cover-image" />
    <div className="d-flex align-items-center">
      <Image src={Icons[el.type.toLowerCase() + 'Colored']} className="card-type-icon" />
      <span>{t('functions.' + el.type.toLowerCase() + '.title')}</span>
    </div>
    <div>
      <h4>{el.title}</h4>
      {el.intro ?
        <p>
          {el.intro.length > 200 ?
            `${el.intro.substring(0, 200)}...` : el.intro
          }
        </p>
        : undefined}
      <p>
        <small>
          <i>{AppUtils.convertDateToLocaleDate(el.datePublished, t('format.date.news'))}</i>
          <span className="mx-2">&#x2022;</span>
          <i>{el.organizationName}</i>
        </small>
      </p>
    </div>
  </div>
)

export default NewsCard;